import * as $ from 'jquery';

import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';

/**
 * GenericPDFFiller module implementation.
 *
 * @author tzhveig1
 * @class GenericPDFFiller
 * @extends Tc.Module
 */
export default class GenericPDFFiller extends Module {
	private $button! : JQuery;
	private $parentForm! : JQuery;
	private $parentFormContents! : JQuery<any>;
	private $submitForm! : JQuery;

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {
		this.$button = this.$ctx.find('.button');
		const url = this.$ctx.data('url');

		this.$parentForm = this.$button.parents('form');
		this.$parentFormContents = this.$parentForm.contents();
		this.$submitForm = $('<form />', {method : 'post', action : url, target : '_blank'});

		this.attachHandlers();
		callback();
	}
	private attachHandlers() {
		this.$button.on('click', this.submitForm.bind(this));
	}
	private submitForm(evt : JQuery.ClickEvent) {
		evt.preventDefault();
		if(this.$ctx.data('validate')) {
			const formApi = this.$parentForm.parent().data('form-api');
			formApi.onFormValidate(this.sendResult.bind(this));
		} else {
			this.sendResult();
		}
	}
	private sendResult() {
		this.$submitForm.append(this.$parentFormContents.detach());
		// tslint:disable-next-line:max-line-length
		$("input[name=':formid'],input[name=':formEntryId'],input[name='_charset_'],input[name=':cq_csrf_token'],[name=':formstart'],[name=':formtype']", this.$submitForm).remove();
		this.$submitForm.appendTo(document.body).trigger('submit').detach();
		this.$parentForm.append(this.$parentFormContents.detach());
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/pdf/Tc.Module.GenericPDFFiller.ts